const translation = {

    'logout_ask': 'Êtes-vous sûr de vouloir vous déconnecter et quitter?',
    'logout_confirmButtonText': 'Terminer la session',
    'logout_cancelButtonText': 'Annuler',
    'logout_title': 'À bientôt!',
    'logout_logout': 'Votre session a été terminée.',


    // CONTACT LEAD
    'contact_lead': 'Veuillez remplir le formulaire suivant pour nous contacter',

    // ORDER DETAIL
    'Order detail': 'Détail de la commande',

    // MINOR DETAILS
    'telefono_celular': 'Téléphone mobile',
    'created': 'Date de création',
    'modified': 'Date de dernière modification',
    'min_read': 'min. de lecture',

    'Not found': 'Non trouvé',
    'The article or page you are looking for could not be found.': 'L\'article ou la page que vous recherchez est introuvable.',

    // BRDIGEROCKS WORLD

    // HOME
    'building the future': 'CONSTRUIRE L\'AVENIR',
    'home': 'Accueil',
    'about': 'À propos',
    'services': 'Services',
    'insights': 'Perspectives',
    'contact': 'Contact',
    'projects': 'Projets',
    'contact us': 'Contactez-nous',
    'who we are': 'Qui sommes-nous',
    'learn more': 'En savoir plus',
    'what we solve': 'Ce que nous résolvons',
    'fundation': 'Fondamentaux',
    'why now': 'Pourquoi maintenant?',
    'why now?': 'Pourquoi maintenant?',
    'latest insights': 'Dernières perspectives',
    'read more': 'Lire plus',
    'read article': 'Lire l\'article',
    'close' : 'Fermer',
    'our team': 'Notre équipe',
    'view all articles': 'Voir tous les articles',
    'explore all projects': 'Explorez tous les projets',
    'featured projects': 'Projets en vedette',
    'view project': 'Voir le projet',
    'get in touch': 'Contactez-nous',
    'email': 'Adresse e-mail',
    'phone': 'Téléphone',
    'address': 'Adresse',
    'headquarters': 'Siège social',
    'business hours': 'Heures d\'ouverture',
    'send message': 'Envoyer un message',
    'message sent': 'Message envoyé',
    'bridge to a world of opportunities': 'Un pont vers un monde de possibilités',
    'company': 'Entreprise',
    'vision': 'Vision',
    'our ecosystem': 'Notre écosystème',
    'advisory': 'Conseil',
    'capital': 'Capital',
    'corporate services': 'Services aux entreprises',
    'page': 'Page',
    'venture creation': 'Création d\'entreprises',
    'property innovation': 'Innovation immobilière',
    'connect': 'Connecter',
    'all rights reserved': 'Tous droits réservés',
    'site map': 'Plan du site',
    'built for visionaries': 'Conçu pour les visionnaires',
    'bridgerocks world functions': 'Fonctions De Bridgerocks World',
    'manifest': 'Manifeste',
    'Full Name' : 'Nom complet',
    'Company': 'Compañía',
    'Title': 'Titre',
    'Email Address': 'Adresse e-mail',
    'Phone Number': 'Numéro de téléphone',
    'Country': 'Pays',
    'Select a country': 'Sélectionnez un pays',
    'Preferred Contact Method': 'Méthode de contact préférée',
    'Select a Contact Method': 'Sélectionnez une méthode de contact',
    'How can we help?': 'Comment pouvons-nous vous aider?',
    'Select a Connection Type': 'Sélectionnez un type de connexion',
    'Select a Bridgerocks Area': 'Sélectionnez une zone Bridgerocks',
    'Bridgerocks Area': 'Zone Bridgerocks',
    'Investor Profile': 'Profil de l\'investisseur',
    'Select an Investor Profile': 'Sélectionnez un profil d\'investisseur',
    'Select an Investment Interest': 'Sélectionnez un intérêt d\'investissement',
    'Capital Range': 'Plage de capital',
    'Select a Capital Range': 'Sélectionnez une plage de capital',
    'Investment Timeframe': 'Délai d\'investissement',
    'Select a Timeframe': 'Sélectionnez un délai',

    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    'Corporate': 'Corporatif',
    'Opportunity Portfolio': 'Portefeuille d’opportunités',
    'Connect With Us': 'Contactez-nous',
    'Explore Corporate Services': 'Découvrez les services aux entreprises',
    'Explore the Opportunity Portfolio': 'Découvrez le portefeuille d’opportunités',

    // showRealEstateFields
    'General Inquiry': 'Demande générale',
    'Investment & Capital': 'Investissement et capital',
    'Real Estate & Hospitality': 'Immobilier et hôtellerie',
    'Strategic Partnership or Joint Venture': 'Partenariat stratégique ou coentreprise',
    'Technology & Venture Opportunities': 'Opportunités technologiques et entrepreneuriales',
    'Land or Property Submission': 'Soumission de terrain ou de propriété',
    'Professional Services or Supplier Introduction': 'Services professionnels ou présentation de fournisseur',
    'Media, Institutional or Community Inquiry': 'Demande médiatique, institutionnelle ou communautaire',
    'Careers & Talent': 'Carrières et talents',
    'Existing Relationship or Project Follow-Up': 'Suivi d’une relation ou d’un projet existant',
    'General Corporate Inquiry': 'Demande générale concernant l’entreprise',
    'Other': 'Autre',
    'Bridgerocks Group': 'Groupe Bridgerocks',
    'Bridgerocks Corporate Management & Operations': 'Gestion et opérations corporatives de Bridgerocks',
    'Reyrock Properties': 'Propriétés Reyrock',
    'Reyrock Talents': 'Talents Reyrock',
    'Reyrock Ventures': 'Entreprises Reyrock',
    'Not sure — please direct my inquiry': 'Je ne suis pas certain(e) — veuillez orienter ma demande',
    'How can we help you?': 'Comment pouvons-nous vous aider?',
    'I agree to the Privacy Policy.': 'J’accepte la politique de confidentialité.',
    'Management': 'Gestion',
    'Talent': 'Talent',
    'Reyrock': 'Reyrock',
    'Privacy Policy': 'Politique de confidentialité',
    'Terms of Service': 'Conditions d’utilisation',

    'built on the r.o.c.k.s. framework': 'Construit sur le cadre R.O.C.K.S.',
    'resources. opportunities. knowledge. strategies & services.': 'Ressources. Opportunités. Connaissances. Stratégies et services.',
    'this proprietary model ensures that every idea receives': 'Ce modèle propriétaire garantit que chaque idée reçoit',
    'resources': 'Ressources',
    'capital, infrastructure, systems': 'capital, infrastructure, systèmes',
    'opportunities': 'Opportunités',
    'incubation, venture creation, real estate, talent development': 'incubation, création d\'entreprises, immobilier, développement des talents',
    'corporate knowledge': 'Connaissances corporatives',
    'governance, advisory, legal, finance': 'gouvernance, conseil, juridique, finances',
    'strategies & services': 'Stratégies et services',
    'execution across tech, marketing, operations': 'exécution en technologie, marketing, opérations',
    'function': 'Fonction',
    'role': 'Rôle',
    'architect': 'Architecte',
    'designs frameworks and structures for growth.': 'Conçoit des cadres et structures pour la croissance.',
    'integrator': 'Intégrateur',
    'aligns and connects multiple divisions and ventures.': 'Aligne et connecte plusieurs divisions et entreprises.',
    'guardian': 'Gardien',
    'protects brand integrity, legal foundations, and vision.': 'Protège l\'intégrité de la marque, les fondements juridiques et la vision.',
    'empowerer': 'Responsabilisant',
    'provides tools, capital, systems, and strategic leverage.': 'Fournit des outils, du capital, des systèmes et un effet de levier stratégique.',

    // BRIDGEROCKS WORLD SERVICES
    'Know more': 'En savoir plus',
    'Corporate Structuring & Incorporation': 'Structuration et constitution d’entreprise',
    'Multinational setups, tax optimization': 'Structures multinationales, optimisation fiscale',
    'Legal Entity Formation & Compliance': 'Création d’entités juridiques et conformité',
    'Business Modeling & Go-to-Market Strategy': 'Modélisation commerciale et stratégie de mise sur le marché',
    'Board Governance Setup & Advisory': 'Mise en place et conseil en gouvernance du conseil d’administration',
    'Risk Management & Liability Protection': 'Gestion des risques et protection contre la responsabilité',
    'Exit Planning & Strategic Partnerships': 'Planification de la sortie et partenariats stratégiques',
    'Succession Planning for Founders': 'Planification de la succession pour les fondateurs',
    'Our services': 'Nos services',
    'FRACTIONAL CXO SERVICDES': 'Services de direction à temps partagé',
    'CFO, CMO, CTO': 'DFG, DMC, DTI',
    'BACK OFFICE-AS-A-SERVICE': 'Back-office en tant que service',
    'Admin, HR, Payroll, Procurement': 'Administration, RH, paie, achats',
    'ACCOUNTING & BOOK KEEPING': 'Comptabilité et tenue des livres',
    'LEGAL SUPPORT': 'Soutien juridique',
    'IP, contracts, licensing': 'Propriété intellectuelle, contrats, licences',
    'TECH DEVELOPMENT': 'Développement technologique',
    'Via IT + software partners': 'Par l’intermédiaire de partenaires informatiques et logiciels',
    'BRAND STRATEGY & DESIGN EXECUTION': 'Stratégie de marque et exécution du design',
    'DIGITAL MARKETING & GROWTH OPS': 'Marketing numérique et opérations de croissance',
    'CRM & SALES INFRASTRUCTURE SETUP': 'Mise en place du CRM et de l’infrastructure commerciale',
    'REGULATORY & LICENSING COMPLIANCE': 'Conformité réglementaire et aux exigences de licence',
    'By sector and geography': 'Par secteur et zone géographique',
    'OUR SERVICES': 'NOS SERVICES',
    'EQUITY & DEBT CAPITAL ADVISORY': 'Conseil en capital-actions et dette',
    'FUNDRAISING STRATEGY (SEED TO SERIES C)': 'Stratégie de levée de fonds (de l’amorçage à la série C)',
    'INVESTOR PITCH COACHING & DEAL STRUCTURING': 'Accompagnement du pitch investisseur et structuration des transactions',
    'FINANCIAL MODELING & VALUATION': 'Modélisation financière et valorisation',
    'CAP TABLE DESIGN & SHAREHOLDER AGREEMENTS': 'Conception de la table de capitalisation et accords entre actionnaires',
    'ACCESS TO INVESTORS, FUNDS, AND ANGEL NETWORKS': 'Accès aux investisseurs, fonds et réseaux d’investisseurs providentiels',
    'PROJECT-BASED INVESTMENT VEHICLES': 'Véhicules d’investissement par projet',
    '(e.g. SPVs)': '(par exemple, des SPV)'

    
}

export { translation };
